import { useState, useEffect } from 'react';
import { AudioStreamer } from './audioStreamer';

interface AudioStreamerState {
  isConnected: boolean;
  isRecording: boolean;
  isCollectRecordings: boolean;
  recordedAudioChunkCount: number;
}

/**
 * A react hook to synchornize an AudioStreamer's state with React state.
 */
export function useAudioStreamerState(
  streamer: AudioStreamer | null,
): AudioStreamerState {
  const [state, setState] = useState<AudioStreamerState>({
    isConnected: false,
    isRecording: false,
    isCollectRecordings: false,
    recordedAudioChunkCount: 0,
  });

  useEffect(() => {
    if (!streamer) {
      return;
    }
    const syncState = () => {
      const newState = {
        isConnected: streamer.isConnected(),
        isRecording: streamer.isRecording(),
        isCollectRecordings: streamer.isCollectingRecordings(),
        recordedAudioChunkCount: streamer.getRecordedAudioChunkCount(),
      };
      setState(newState);
    };

    // Initial sync
    syncState();

    // Subscribe to state changes
    const handleStateChange = () => {
      syncState();
    };

    streamer.addEventListener('stateChange', handleStateChange);

    // Cleanup
    return () => {
      streamer.removeEventListener('stateChange', handleStateChange);
    };
  }, [streamer]);

  return state;
}
